/**
 * Pure elapsed-time helpers for the remote-support room header (D-02).
 *
 * No React, no DOM - kept importable by both the header component and Phase 5's vitest suite
 * (BASELINE.md: no frontend test runner exists yet, so this module is written to be trivially
 * testable once one does).
 */

/**
 * Formats a duration in seconds as `m:ss` below one hour, `h:mm:ss` from one hour up.
 * Negative input clamps to zero rather than showing a negative duration.
 */
export function formatElapsed(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds))
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = seconds % 60

  if (h > 0) {
    return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
  }
  return `${m}:${s.toString().padStart(2, '0')}`
}

/**
 * Derives the wall-clock instant (ms since epoch) both sides joined, from the server-computed
 * `activatedAgoMs` returned alongside `receivedAtMs` (this browser's own clock reading at the
 * moment the response arrived).
 *
 * Anchoring on the server's own "how long ago" figure, rather than on a server timestamp compared
 * against the client clock, means a wrong client clock never changes the elapsed time shown (D-02)
 * - it only ever changes the fixed anchor an elapsed-seconds counter ticks up from, and that
 * ticking uses the same client clock consistently on both sides of the subtraction.
 */
export function elapsedAnchorFromAgo(receivedAtMs: number, agoMs: number): number {
  return receivedAtMs - agoMs
}
